import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { AlertService } from '@app/core/services/alert/alert.service';
import { ModalController, NavController, NavParams, Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-user-type-options',
  templateUrl: './user-type-options.page.html',
  styleUrls: ['./user-type-options.page.scss'],
})
export class UserTypeOptionsPage implements OnInit, AfterViewInit, OnDestroy {
  public options: any[];
  public optionsLength: number;
  public results: string[] = [];
  backButtonSubscription: Subscription;
  //@Output() selectedOption = new EventEmitter();
  constructor(
    private renderer: Renderer2,
    private elementRef: ElementRef,
    private navParams: NavParams,
    private modalCtrl: ModalController,
    private platform: Platform,
    private alertService: AlertService,
    private translateService: TranslateService,
    private navCtrl: NavController
  ) {}

  ngAfterViewInit() {
    this.backButtonSubscription = this.platform.backButton.subscribeWithPriority(10, () => {
      this.showConfirmation();
    });
    // Remove the 'ion-page' class from the modal's root element
    const modalElement = this.elementRef.nativeElement;
    this.renderer.removeClass(modalElement, 'ion-page');
  }

  ngOnInit() {
    this.options = this.navParams.get('options');
    this.optionsLength = this.options.length;

    this.options.forEach((element) => {
      if (element !== null) {
        this.results.push(element);
      }
    });
  }
  ngOnDestroy() {
    this.backButtonSubscription.unsubscribe();
  }

  selectOption(index: number) {
    this.modalCtrl.dismiss(index);
    //this.selectedOption.emit(res);
  }

  async onClose() {
    this.modalCtrl.dismiss();
  }

  async showConfirmation() {
    const header = this.translateService.instant('CONFIRMATION');
    const message = this.translateService.instant('CANCEL_PRINT_MSG');
    const yes = this.translateService.instant('YES');
    const no = this.translateService.instant('NO');
    await this.alertService.customAlert(header, message, '', [
      {
        text: no,
        role: 'no',
      },
      {
        text: yes,
        role: 'yes',
        handler: async () => {
          await this.modalCtrl.dismiss();
          this.navCtrl.navigateBack('app/add-files');
        },
      },
    ]);
  }
}
